import {
  organizerInfoSelector,
  organizerIsLoadedSelector,
  organizerIsLoadingSelector,
  organizerIsSavingSelector,
} from 'modules/organizer/store/orginizer/selectors';

import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export const useOrganizer = () => {
  const isLoading = useSelector(organizerIsLoadingSelector);
  const isLoaded = useSelector(organizerIsLoadedSelector);
  const isSaving = useSelector(organizerIsSavingSelector);
  const info = useSelector(organizerInfoSelector);

  return useMemo(
    () => ({
      isLoading,
      isLoaded,
      isSaving,
      info,
    }),
    [isLoading, isLoaded, isSaving, info],
  );
};
